import { ApiHandler, HasOnComplete, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import { WishListCollectionModel } from "@insite/client-framework/Types/ApiModels";

export interface GetWishListsApiParameterUpdated extends Omit<GetWishListsApiParameter, "expand"> {
    expand?: "wishlistlines"[] | "top3products"[];
}

type HandlerType = ApiHandler<GetWishListsApiParameter & HasOnComplete, WishListCollectionModel>;

export const PopulateApiParameterExtended: HandlerType = props => {
    const { onComplete, ...apiParameter} = props.parameter;
    // props.apiParameter = apiParameter;

    props.apiParameter = {
        ...props.parameter,
        expand: ["wishlistlines","top3products","favorite","hidden","tags",] as any,
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtended);
